import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=e63000be&scoped=true&"
var script = {}
import style0 from "./Services.vue?vue&type=style&index=0&id=e63000be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63000be",
  null
  
)

export default component.exports